/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetProfessionRequest = {
  properties: {
    professionId: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
